import axios from 'axios'
import store from 'store'
// import { notification } from 'ant-design-vue'

// import Swal from 'sweetalert2'

// const Toast = Swal.mixin({
//   toast: true,
//   position: 'top-end',
//   showConfirmButton: false,
//   timer: 8000,
//   timerProgressBar: true,
//   didOpen: (toast) => {
//     toast.addEventListener('mouseenter', Swal.stopTimer)
//     toast.addEventListener('mouseleave', Swal.resumeTimer)
//   },
// })

const apiClient2 = axios.create({
  baseURL: process.env.VUE_APP_API_URL_V2,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Private-Network': true,
  },
  // timeout: 1000,
  // headers: { 'X-Custom-Header': 'foobar' }
})

apiClient2.interceptors.request.use(request => {
  const accessToken = store.get('accessToken')
  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`
    request.headers.AccessToken = accessToken
  }
  return request
})

// apiClient2.interceptors.response.use(response => {
//   return response
// }, error => {
//   const errorPro = { ...error.response }
//   if (errorPro) {
//     Toast.fire({
//       icon: 'error',
//       title: errorPro.data.error.message,
//     })
//   }
//   return Promise.reject(error)
// })

export default apiClient2
